module.exports = __webpack_public_path__ + "images/backgrounds/hex.2e2cb18ce229869faec8.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/hex.png
// module id = mlU4
// module chunks = 0